export default __webpack_public_path__ + "assets/images/e5d8ff8714e0bf535af8c56b3ee08a16.png";